import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/UserSlice";
import authReducer from "../features/AuthSlice";
import firstLoginReducer from "../features/FirstLoginSlice";
import setupAccountReducer from "../features/SetupAccountSlice";
import topPlanReducer from "../features/TopPlanSlice";
import perfCycleDetailsReducer from "../features/PerfCycleSlice";
import positionDetailsReducer from "../features/PositionSlice";

export const Store = configureStore({
  reducer: {
    userState: userReducer,
    authState: authReducer,
    firstLoginState: firstLoginReducer,
    setupAccountState: setupAccountReducer,
    topPlanState: topPlanReducer,
    perfCycleState: perfCycleDetailsReducer,
    positionState: positionDetailsReducer,
  },
});
